import { render, staticRenderFns } from "./linkResourceGroup.vue?vue&type=template&id=474cb9b7&"
import script from "./linkResourceGroup.vue?vue&type=script&lang=js&"
export * from "./linkResourceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports